export default __webpack_public_path__ + "static/media/photo--sm--alaina-3.00cad7e1.jpg";